import {
  Button,
  createStyles,
  IconButton,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import React from "react";
import CancelIcon from "@material-ui/icons/Cancel";
import { useDispatch } from "react-redux";
import {
  onRejectPendingRequest,
  selectPendingRequest,
} from "../../../redux/actions/types/pendingRequestTypes";
import { useTranslation } from "../../../hooks/useTranslation";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      color: "#D00000",
    },
  })
);

type CancelButtonProps = {
  rowData: any;
  isMobile?: boolean;
};

const CancelButton = ({ rowData, isMobile }: CancelButtonProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t, BundleKey } = useTranslation();

  const onClickReject = () => {
    dispatch(onRejectPendingRequest(true));
    dispatch(selectPendingRequest(rowData));
  };

  return (
    <Tooltip title={t(BundleKey.ACTION_REJECT).toString()}>
      {isMobile ? (
        <Button size="small" onClick={onClickReject} className={classes.root}>
          {t(BundleKey.ACTION_REJECT)}
        </Button>
      ) : (
        <IconButton
          aria-label="reject"
          onClick={onClickReject}
          className={classes.root}
        >
          <CancelIcon fontSize="large" />
        </IconButton>
      )}
    </Tooltip>
  );
};

export default CancelButton;
